// MUI
import { Button } from "@mui/material";

// Hooks
import { useAuthorization } from "@Common/hooks/Authorization/Authorization";

// Constants
import actionsList from "@Constants/actionsList";

type PayOutboundCommissionsButtonsProps = {
	isExportable: boolean;
	isDataLoading: boolean;
	// Callbacks
	onClick: () => void;
};
export default function PayCrossStoreCommissionsButton(props: Readonly<PayOutboundCommissionsButtonsProps>) {
	const { isExportable, isDataLoading, onClick } = props;

	const { useAuth } = useAuthorization();

	const hasExportPermission = useAuth(actionsList.EXPORT_CROSS_STORE_RECONCILIATION_REPORT);

	return (
		<Button variant={"contained"} color={"primary"} onClick={onClick} disabled={!hasExportPermission || isDataLoading || !isExportable}>
			Pay Cross-Store Commissions
		</Button>
	);
}
